<!-- 查看公钥弹窗 -->
<template>
  <el-dialog
    class="data-migration-add-server-config-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="serverDateForm"
      :model="serverDateForm"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-dynamic"
    >
      <el-form-item class="server-long" prop="email" label="服务器IP地址">
        <el-input v-model="serverDateForm.ip" :disabled="title == '修改服务器配置'"></el-input>
      </el-form-item>

      <el-form-item class="server-long" prop="email" label="服务器名称">
        <el-input v-model="serverDateForm.servername"></el-input>
      </el-form-item>

      <el-form-item :label="'已部署服务端口'">
        <el-select
          v-model="serverDateForm.serverID"
          placeholder="请选择"
          @change="serveridChange()"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input v-model="serverDateForm.serverport"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="addServerFn()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddServerConfig',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '',
      loadingBtn: false,
      dialogVisible: false,
      userid: '',
      isPing: false,
      serverDateForm: {
        ip: '', //服务ip
        servername: '', //服务器名称
        serverport: '',
        serverID: null,
        domains: [
          {
            serverID: null,
            serverport: null,
            isPing: false
          }
        ]
      },
      options: [
        {
          value: 4,
          label: '数据迁移'
        }
      ],
      value: [],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    addDomain() {
      this.serverDateForm.domains.push({
        serverID: null,
        serverport: null,
        isPing: false
      })
    },
    removeDomain(index) {
      this.serverDateForm.domains.splice(index, 1)
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      if (data.title == '修改服务器配置') {
        var dataObj = data
        dataObj.domains = data.domains
        this.$set(this.serverDateForm, 'id', data.ip)
        this.$set(this.serverDateForm, 'servername', data.servername)
        this.$set(this.serverDateForm, 'ip', data.ip)
        this.$set(this.serverDateForm, 'domains', data.domains)
      } else {
        this.$set(this.serverDateForm, 'id', '')
        this.$set(this.serverDateForm, 'servername', '')
        this.$set(this.serverDateForm, 'ip', '')
        this.$set(this.serverDateForm, 'domains', [
          {
            serverID: null,
            serverport: null,
            isPing: false
          }
        ])
      }

      this.dialogVisible = true
      this.title = data.title
    },
    addServerFn() {
      let serviceAddress = 'http://' + this.serverDateForm.ip + ':' + this.serverDateForm.serverport
      let url = `${serviceAddress}/transfer/ping`
      this.$apis.datamigration.addServer(url, {}).then(res => {
        if (res.data.code != 200) {
          this.$message.error(res.message)
        } else {
          this.$message.success('链接服务成功')
          this.addList()
        }
      })
    },
    addList() {
      var formObj = {}
      var obj = {}
      let encryptsvrs = []
      // formObj.userid = String(userInfo.ID)
      formObj.ip = this.serverDateForm.ip
      obj.serverID = this.serverDateForm.serverID
      formObj.servername = this.serverDateForm.servername

      obj.serverport = Number(this.serverDateForm.serverport)
      encryptsvrs.push(obj)
      formObj.encryptsvrs = encryptsvrs

      let params = JSON.stringify(formObj)

      this.$apis.excellent.encryptConfigAdd(params).then(res => {
        if (res.code != 0) {
          this.$message.success('添加成功！')
          this.$emit('getList')
          this.dialogVisible = false
        } else {
          if(res.error && res.error[0] && res.error[0].message) {
            this.$message.error('添加失败！' + res.error[0].message)
          } else {
            this.$message.error('添加失败！');
          }
          
          this.$emit('getList')
        }
        return
      })
    },
    serveridChange() {
      if (this.serverDateForm.serverID == 4) {
        this.serverDateForm.serverport = 12091
      }
    }
  }
}
</script>

<style scoped lang="scss">
.data-migration-add-server-config-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
